<template>
    <div>
        <div
            class="min-height-300 position-absolute w-100"
            style="background-color: #d6e4e5"
        />
        <main class="main-content position-relative max-height-vh-100 h-100">
            <navbar />
            <router-view />
            <app-footer />
        </main>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import AppFooter from "../components/Footer.vue";
import { mapGetters } from "vuex";

export default {
    name: "App",
    components: {
        Navbar,
        AppFooter,
    },
    data() {
        return {};
    },
    created() {
        // this.fetchTimeSetting();
    },
    methods: {},
    computed: {
        ...mapGetters(["Profile"]),
    },
};
</script>

<style scoped>
.station-container {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 100%;
    height: 100%;

    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: #d6e4e5;
}

.station-container img {
    width: 150px;
    margin-bottom: 40px;
}

#account-actions-mobile {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 4;
    width: 100%;
}

@media (min-width: 992px) {
    #account-actions-mobile {
        display: none;
    }
}

#account-actions-mobile .-outer-wrapper {
    display: flex;
    align-items: flex-end;
}

#account-actions-mobile .-left-wrapper,
#account-actions-mobile .-right-wrapper {
    display: flex;
    align-items: flex-end;
    flex: 1;
    z-index: 2;
    height: 70px;
    padding-bottom: 6px;
    background: linear-gradient(180deg, #d6e4e5, #d6e4e5);
    transition: -webkit-filter 0.2s;
    transition: filter 0.2s;
    transition: filter 0.2s, -webkit-filter 0.2s;
}

#account-actions-mobile .-center-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    z-index: 2;
    width: 74px;
    height: 74px;
    margin: 0 8px 16px;
    padding-bottom: 0px;
    color: #fff;
    border-radius: 60%;
    box-shadow: 0 0 10px hsla(0, 0%, 100%, 0.4);
    background: linear-gradient(180deg, #fbc844, #f88012);
}

#account-actions-mobile .-center-wrapper .-selected,
#account-actions-mobile .-center-wrapper .-selecting {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
}

#account-actions-mobile .-center-wrapper .-selected {
    transition: all 0.4s;
    height: 100%;
    width: 100%;
    border-radius: 15%;
}

#account-actions-mobile .-center-wrapper .-selected:before {
    content: "";
    position: relative;
    bottom: 0rem;
    width: 100%;
    height: 100%;
    z-index: 4;
    background-size: 77px;
    background-repeat: no-repeat;
    background-position: bottom;
}

#account-actions-mobile .-center-wrapper .-selected .-text {
    position: relative;
    top: -3px;
    font-size: 0.875rem;
    text-shadow: 1px 3px 5px rgba(0, 0, 0, 0.6);
}

#account-actions-mobile .-center-wrapper .-selected .-bottom-curve,
#account-actions-mobile .-center-wrapper .-selected .-top-curve {
    position: absolute;
    left: 50%;
    z-index: 2;
    width: 85%;
    height: auto;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

#account-actions-mobile .-center-wrapper .-selected .-top-curve {
    top: 3px;
}

#account-actions-mobile .-center-wrapper .-selected .-bottom-curve {
    bottom: 3px;
}

#account-actions-mobile .-center-wrapper:hover {
    color: #fff;
    text-decoration: none;
}

#account-actions-mobile .-fake-center-bg-wrapper {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 50px;
    transition: -webkit-filter 0.2s;
    transition: filter 0.2s;
    transition: filter 0.2s, -webkit-filter 0.2s;
    overflow: hidden;
}

#account-actions-mobile .-fake-center-bg-wrapper svg {
    position: absolute;
    left: 50%;
    bottom: 0;
    height: 108px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

#account-actions-mobile .-fake-center-bg-wrapper svg path {
    fill: url(#rectangleGradient);
}

#account-actions-mobile .-left-wrapper {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

#account-actions-mobile .-right-wrapper {
    border-top-right-radius: 10px;
}

#account-actions-mobile .-sub-menu-lobby-wrapper {
    position: absolute;
    flex-direction: row;
    justify-content: center;
    visibility: hidden;
    top: -75px;
    left: 50%;
    z-index: 3;
    opacity: 0;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    -webkit-transform: translateX(-50%) translateY(200px) scaleY(2.5)
        scaleX(0.2);
    transform: translateX(-50%) translateY(200px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    transition: all 0.2s;
}

#account-actions-mobile .-sub-menu-lobby-wrapper .nav-item .-img {
    margin-top: -8px;
    width: 56px;
    height: auto;
}

#account-actions-mobile .-sub-menu-lobby-wrapper .nav-item .-text {
    display: inline-block;
    font-size: 10px;
    line-height: 12px;
    -webkit-transform: translateY(-12px);
    transform: translateY(-12px);
}

@media (max-width: 991.98px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-casino
        .-nav-icon-bg {
        background-position: 3px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-casino
        .-nav-icon-bg {
        background-position: 0 0;
    }
}

@media (max-width: 991.98px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-slot
        .-nav-icon-bg {
        background-position: -73px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-slot
        .-nav-icon-bg {
        background-position: -75px;
    }
}

@media (max-width: 991.98px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-skill-game
        .-nav-icon-bg {
        background-position: -147px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-skill-game
        .-nav-icon-bg {
        top: -12px;
        background-position: -150px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-skill-game
        .-text {
        -webkit-transform: translateY(-6px);
        transform: translateY(-6px);
    }
}

@media (max-width: 991.98px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-sport
        .-nav-icon-bg {
        background-position: -221px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-sport
        .-nav-icon-bg {
        background-position: -224px;
    }
}

@media (max-width: 991.98px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-fishing-game
        .-nav-icon-bg {
        background-position: -300px;
    }
}

@media (max-width: 360px) {
    #account-actions-mobile
        .-sub-menu-lobby-wrapper
        .nav-item.-fishing-game
        .-nav-icon-bg {
        background-position: -303px;
    }
}

#account-actions-mobile .-sub-menu-lobby-wrapper .nav-link {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 66px;
    height: 66px;
    margin: 0 3px;
    padding: 0;
    text-align: center;
    color: #fff;
    background: linear-gradient(180deg, #393854, #131228);
    border: 1px solid hsla(0, 0%, 100%, 0.6);
    border-radius: 50%;
    box-shadow: 0 0 10px hsla(0, 0%, 100%, 0.6);
}

#account-actions-mobile .-sub-menu-lobby-wrapper .nav-link .-nav-icon-bg {
    background-size: 360px;
    background-repeat: no-repeat;
    width: 100%;
    height: 40px;
    top: -15px;
    position: relative;
}

#account-actions-mobile .-sub-menu-lobby-wrapper .nav-link:focus {
    outline: 0;
    text-decoration: none;
}

@media screen and (max-width: 360px) {
    #account-actions-mobile .-sub-menu-lobby-wrapper .nav-item .-img {
        margin-top: -15px;
        width: 54px;
    }

    #account-actions-mobile .-sub-menu-lobby-wrapper .nav-link {
        width: 60px;
        height: 60px;
        margin: 0 2px;
    }
}

#account-actions-mobile .-item-wrapper {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    color: #333;
}

#account-actions-mobile .-item-wrapper .-ic-img {
    width: 32px;
    height: auto;
}

#account-actions-mobile .-item-wrapper .-text {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #333;
    transition: color 0.2s;
}

@media (max-width: 575.98px) {
    #account-actions-mobile .-item-wrapper .-text {
        font-size: 0.8rem;
    }
}

#account-actions-mobile .-item-wrapper:active,
#account-actions-mobile .-item-wrapper:hover {
    text-decoration: none;
}

#account-actions-mobile .-item-wrapper.-register {
    position: relative;
}

#account-actions-mobile .-item-wrapper.-register .-ic-img {
    -webkit-filter: drop-shadow(0 0 3px #f7c16b);
    filter: drop-shadow(0 0 3px #f7c16b);
    -webkit-animation: x-register-bottom-blink 0.5s infinite alternate;
    animation: x-register-bottom-blink 0.5s infinite alternate;
}

#account-actions-mobile .-fully-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: rgba(0, 0, 0, 0.6);
}

#account-actions-mobile.-active .-fake-center-bg-wrapper,
#account-actions-mobile.-active .-left-wrapper,
#account-actions-mobile.-active .-right-wrapper {
    -webkit-filter: brightness(0.5);
    filter: brightness(0.5);
}

#account-actions-mobile.-active .-fake-center-bg-wrapper a,
#account-actions-mobile.-active .-left-wrapper a,
#account-actions-mobile.-active .-right-wrapper a {
    pointer-events: none;
}

#account-actions-mobile.-active .-center-wrapper {
    background: linear-gradient(
        0deg,
        rgba(251, 200, 68, 0.85),
        rgba(248, 128, 18, 0.85)
    );
}

#account-actions-mobile.-active .-center-wrapper .-selected {
    display: none;
}

#account-actions-mobile.-active .-center-wrapper .-selecting {
    display: flex;
}

#account-actions-mobile.-active .-sub-menu-lobby-wrapper {
    visibility: visible;
    opacity: 1;
    -webkit-filter: blur(0);
    filter: blur(0);
    -webkit-transform: translateX(-50%) translateY(0) scaleY(1) scaleX(1);
    transform: translateX(-50%) translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
}

#account-actions-mobile.-active .-fully-overlay {
    display: block;
}
</style>
